var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collapse navbar-collapse", attrs: { id: _vm.toggleID } },
    [
      _c("b-nav", { staticClass: "navbar-nav ml-auto" }, [
        _c(
          "a",
          {
            staticClass: "nav-link",
            attrs: {
              href: "https://www.niem.gov/Pages/default.aspx",
              target: "_blank"
            }
          },
          [_vm._v("NIEM.gov")]
        ),
        _c(
          "a",
          {
            staticClass: "nav-link",
            attrs: { href: "https://niem.github.io", target: "_blank" }
          },
          [_vm._v("Resources")]
        ),
        _c(
          "a",
          {
            staticClass: "nav-link",
            attrs: {
              href: "https://www.niem.gov/Pages/contact.aspx",
              target: "_blank"
            }
          },
          [_vm._v("Contact Us")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }